(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // The mobile drawer rolls back up before it closes. With reduced motion, or when
  // the drawer is hidden, there's no animation to wait for and it closes at once.
  const closeDetails = (details) => {
    if (!details.classList.contains('header__drawer')) {
      details.removeAttribute('open');
      return;
    }

    if (details.classList.contains('is-closing')) return;
    details.classList.add('is-closing');

    const panel = details.querySelector('.header__drawer-panel');
    Promise.all(panel.getAnimations().map((animation) => animation.finished))
      .then(() => {
        if (!details.classList.contains('is-closing')) return;
        details.classList.remove('is-closing');
        details.removeAttribute('open');
      })
      // Reopened mid-close, which cancels the animation.
      .catch(() => {});
  };

  document.addEventListener('click', (event) => {
    const drawer = event.target.closest('.header__drawer > summary')?.parentElement;
    if (drawer?.open) {
      event.preventDefault();
      if (drawer.classList.contains('is-closing')) {
        drawer.classList.remove('is-closing');
      } else {
        closeDetails(drawer);
      }
    }

    document.querySelectorAll('.header details[open]').forEach((details) => {
      if (!details.contains(event.target)) closeDetails(details);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.header details[open]').forEach((details) => {
      closeDetails(details);
      details.querySelector('summary').focus();
    });
  });

  // A hero at the top of the page is pulled up under the header by its exact height.
  let headerResizeObserver;

  const observeHeaderHeight = () => {
    const header = document.querySelector('.header');
    headerResizeObserver?.disconnect();
    if (!header) return;

    headerResizeObserver = new ResizeObserver(() => {
      document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
    });
    headerResizeObserver.observe(header);
  };

  // Once the page moves, the header fills in with the page colours.
  const updateHeaderScrolled = () => {
    document.querySelector('.header')?.classList.toggle('is-scrolled', window.scrollY > 16);
  };

  observeHeaderHeight();
  updateHeaderScrolled();
  window.addEventListener('scroll', updateHeaderScrolled, { passive: true });

  document.addEventListener('shopify:section:load', () => {
    observeHeaderHeight();
    updateHeaderScrolled();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text"] && !Shopify.designMode) return;
  try {
    
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const loadVideo = (video) => {
    if (!video.dataset.src || video.src) return;
    video.src = video.dataset.src;
    video.play().catch(() => {});
  };

  // Videos keep their poster until they come near the viewport. With reduced
  // motion the clip is never fetched and the poster stands in for it.
  const observeVideos = () => {
    const videos = document.querySelectorAll('.image-text__video[data-src]');
    if (!videos.length) return;

    if (reduceMotion) {
      videos.forEach((video) => video.removeAttribute('autoplay'));
      return;
    }

    if (!('IntersectionObserver' in window)) {
      videos.forEach(loadVideo);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        loadVideo(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '300px 0px' });

    videos.forEach((video) => observer.observe(video));
  };

  observeVideos();
  document.addEventListener('shopify:section:load', observeVideos);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-auto-submit]')) event.target.form.requestSubmit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('variant-select')) {
    customElements.define(
      'variant-select',
      class VariantSelect extends HTMLElement {
        connectedCallback() {
          this.querySelector('select').addEventListener('change', (event) => this.update(event.target.value));
        }

        async update(variantId) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variantId);
          window.history.replaceState({}, '', url);
          url.searchParams.set('section_id', this.dataset.section);

          this.controller?.abort();
          this.controller = new AbortController();

          try {
            const response = await fetch(url, { signal: this.controller.signal });
            if (!response.ok) return;

            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            this.closest('.product')
              .querySelectorAll('[data-variant-update]')
              .forEach((element) => {
                const replacement = html.getElementById(element.id);
                if (replacement) element.innerHTML = replacement.innerHTML;
              });
          } catch (error) {
            if (error.name !== 'AbortError') throw error;
          }
        }
      }
    );
  }

  if (!customElements.get('quantity-input')) {
    customElements.define(
      'quantity-input',
      class QuantityInput extends HTMLElement {
        connectedCallback() {
          this.input = this.querySelector('input');
          this.querySelectorAll('button').forEach((button) => {
            button.addEventListener('click', () => this.step(button.name === 'plus' ? 1 : -1));
          });
        }

        step(delta) {
          const min = Number(this.input.min) || 1;
          const next = Math.max(min, (Number(this.input.value) || min) + delta);
          this.input.value = next;
          this.input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
